const ITEMS = [
  { text: "श्री राधे राधे", hindi: true },
  { text: "Banke Bihari Mandir", hindi: false },
  { text: "Prem Mandir", hindi: false },
  { text: "निधिवन", hindi: true },
  { text: "Seva Kunj", hindi: false },
  { text: "Yamuna Aarti", hindi: false },
  { text: "इस्कॉन वृन्दावन", hindi: true },
  { text: "Kesi Ghat", hindi: false },
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span
          className={`mx-10 whitespace-nowrap ${
            item.hindi
              ? "font-hindi text-2xl sm:text-3xl text-saffron"
              : "font-display italic text-2xl sm:text-3xl text-cream/85"
          }`}
        >
          {item.text}
        </span>
        <span className="text-gold text-lg">✦</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    className="relative overflow-hidden border-y border-gold/25 bg-maroon py-6"
    data-testid="editorial-marquee"
    aria-hidden="true"
  >
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
